import Cookies from 'js-cookie';
import {
  ENTRY_SEGMENT,
  ENTRY_SEGMENT_COOKIE,
  ENTRY_SEGMENT_COOKIE_DAYS,
  isEntrySegment,
  mapEntrySegment,
} from './entrySegment';

export const entrySegmentCookieOptions = {
  path: '/',
  sameSite: 'Lax',
  expires: ENTRY_SEGMENT_COOKIE_DAYS,
};

const readLocalEntrySegment = () => {
  try {
    return window.localStorage.getItem(ENTRY_SEGMENT_COOKIE);
  } catch {
    return null;
  }
};

const writeLocalEntrySegment = value => {
  try {
    window.localStorage.setItem(ENTRY_SEGMENT_COOKIE, value);
  } catch {
    // Storage can be unavailable. The cookie still carries the segment.
  }
};

export const resolveEntrySegment = ({
  pathname,
  storedValue,
  storageValue,
} = {}) => {
  if (isEntrySegment(storageValue)) return storageValue;
  if (isEntrySegment(storedValue)) return storedValue;

  return mapEntrySegment(pathname);
};

/**
 * Persist the first landing in both stores. Returns the value to report.
 */
export const ensureEntrySegment = ({
  pathname,
  storedValue,
  storageValue,
  setCookie,
  setStorage,
} = {}) => {
  const segment = resolveEntrySegment({ pathname, storedValue, storageValue });

  if (storageValue !== segment) {
    setStorage?.(segment);
  }
  if (storedValue !== segment) {
    setCookie?.(ENTRY_SEGMENT_COOKIE, segment, entrySegmentCookieOptions);
  }

  return segment;
};

export const readEntrySegment = ({ storedValue, storageValue } = {}) => {
  const storage =
    storageValue === undefined ? readLocalEntrySegment() : storageValue;
  const cookie =
    storedValue === undefined ? Cookies.get(ENTRY_SEGMENT_COOKIE) : storedValue;

  if (isEntrySegment(storage)) return storage;
  if (isEntrySegment(cookie)) return cookie;

  return ENTRY_SEGMENT.TARGETED_PAGE;
};

/**
 * Record entry_segment on the client, before the Flagship Test effect reads it.
 * Restores the first landing when a later response replaced the cookie.
 */
export const ensureEntrySegmentCookie = () => {
  if (typeof window === 'undefined') return undefined;

  return ensureEntrySegment({
    pathname: window.location.pathname,
    storedValue: Cookies.get(ENTRY_SEGMENT_COOKIE),
    storageValue: readLocalEntrySegment(),
    setCookie: (name, value, options) => Cookies.set(name, value, options),
    setStorage: writeLocalEntrySegment,
  });
};
